import { Status, FundStatus } from "consts/transactions";
import { Column } from "./types";

export const status = new Map<Status, Column>([
    [Status.Succeeded, Column.SucceededAt],
    [Status.Failed, Column.FailedAt],
    [Status.Rejected, Column.RejectedAt],
    [Status.Refunded, Column.RefundedAt],
    [Status.ChargeBack, Column.ChargedBackAt]
]);

export const fundStatus = new Map<FundStatus, Column>([
    [FundStatus.Waiting, Column.FundsWaitingAt],
    [FundStatus.Received, Column.FundsReceivedAt],
    [FundStatus.Missing, Column.FundsMissingAt],
    [FundStatus.Sent, Column.FundsSentAt],
    [FundStatus.PartiallySent, Column.FundsPartiallySentAt],
    [FundStatus.NotExpected, Column.FundsNotExpectedAt],
    [FundStatus.Refunded, Column.FundsRefundedAt],
    [FundStatus.PartiallyRefunded, Column.FundsPartiallyRefundedAt],
    [FundStatus.PartiallySentRefunded, Column.FundsPartiallySentRefundedAt],
    [FundStatus.PartiallyRefundedSent, Column.FundsPartiallyRefundedSentAt],
    [FundStatus.FullySent, Column.FundsFullySentAt],
    [FundStatus.FullyRefunded, Column.FundsFullyRefundedAt],
    [FundStatus.FullySentRefunded, Column.FundsFullySentRefundedAt],
    [FundStatus.FullyRefundedSent, Column.FundsFullyRefundedSentAt],
    [FundStatus.Deducted, Column.FundsDeductedAt]
]);
